import { buildDeserializer, buildSerializer } from "lib/serializerUtils";
import { passThroughDeserializer } from "lib/reducers";

export const serializeMasterRuleSet = buildSerializer(
  passThroughDeserializer,
  "masterRuleSet",
);
export const deserializeMasterRuleSet = buildDeserializer(
  passThroughDeserializer,
  "masterRuleSet",
);
